import { useMemo } from 'react';

export const useNumberSeparators = (appLanguage = 'en', country = 'US') =>
    useMemo(() => {
        const browserLanguage = typeof navigator !== 'undefined' ? navigator.language?.split('-')[0] : '';
        const locale = appLanguage === browserLanguage ? navigator?.language : `${appLanguage}-${country.toUpperCase()}`;

        const parts = new Intl.NumberFormat(locale).formatToParts(1234567.89);

        const thousandSeparator = parts.find((part) => part.type === 'group')?.value || ',';
        const decimalSeparator = parts.find((part) => part.type === 'decimal')?.value || '.';

        return { thousandSeparator, decimalSeparator };
    }, [appLanguage, country]);
